/**
 * Remembers whether the user collapsed the board's left nav, so it stays the
 * way they left it across reloads and route changes.
 *
 * Kept here rather than in @onetasklist/shared because the shared library must
 * not touch `localStorage`, and the collapsed rail is web-only — the mobile app
 * uses a drawer, whose open state is deliberately ephemeral
 * (src/ClientApp-React/src/contexts/MobileSidebarContext.tsx).
 *
 * Every access is guarded: `localStorage` throws on access in some private
 * browsing modes, and is absent entirely when the bundle is evaluated without
 * a DOM.
 */

export const SIDEBAR_COLLAPSED_STORAGE_KEY = "otl-sidebar-collapsed";

/**
 * Whether the left nav should start collapsed. Defaults to `false` when nothing
 * is remembered, or when storage is unreadable.
 */
export const getSidebarCollapsed = (): boolean => {
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

/** Records whether the left nav is collapsed, for the next load. */
export const setSidebarCollapsed = (isCollapsed: boolean): void => {
  try {
    window.localStorage.setItem(
      SIDEBAR_COLLAPSED_STORAGE_KEY,
      String(isCollapsed),
    );
  } catch {
    // Storage is full or blocked — remembering the nav state is best-effort.
  }
};
